<template>
  <b-modal
    id="receipt-modal"
    :visible="visible"
    hide-footer
    centered
    content-class="receipt-modal-content"
    dialog-class="receipt-modal-dialog"
    header-bg-variant="primary"
    :title="$t('receipt.confirmTitle')"
    @hide="handleClose"
  >
    <!-- <template #modal-header>
      <div class="d-flex justify-content-between align-items-center w-100">
        <span class="receipt-title text-success font-weight-bold">
          {{ $t('receipt.confirmTitle') }}
        </span>
        <b-button
          variant="link"
          class="p-0 close-btn"
          @click="handleClose"
        >
          <b-icon
            icon="x"
            font-scale="1.5"
          />
        </b-button>
      </div>
    </template> -->
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-list-group class="mb-3 receipt-list-group">
        <b-list-group-item class="bg-light d-flex justify-content-between align-items-center border-0">
          <div>
            <span>{{ $t('receipt.withdrawFromWallet') }}</span>
            <br>
            <span class="font-weight-bold">{{ getBrandName() }}</span>
          </div>
          <span>{{ $t('date') }}: {{ new Date().toLocaleString(citizenship()==='iran'?'fa-IR':'en-US') }}</span>
        </b-list-group-item>
        <b-list-group-item
          v-if="address"
          class="d-flex justify-content-between align-items-center border-0"
        >
          <span>{{ $t('address') }}:</span>
          <span>{{ address }}</span>
        </b-list-group-item>
        <b-list-group-item
          v-if="iban"
          class="d-flex justify-content-between align-items-center border-0"
        >
          <span>{{ $t('iban') }}:</span>
          <span>{{ iban }}</span>
        </b-list-group-item>
        <b-list-group-item
          v-if="network"
          class="bg-light d-flex justify-content-between align-items-center border-0"
        >
          <span>{{ $t('Network') }}:</span>
          <span>{{ network && network.toUpperCase() }}</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex justify-content-between align-items-center border-0">
          <span>{{ $t('currency') }}:</span>
          <span>{{ currency && currency.toUpperCase() }}</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex justify-content-between align-items-center border-0">
          <span>{{ $t('amount') }}:</span>
          <span dir="ltr">{{ amount && amount.toString().toUpperCase() }}</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex flex-column border-0">
          <div class="d-flex justify-content-between align-items-center w-100">
            <span>{{ $t('fee') }}: </span>
            <span dir="ltr">{{ fee }} {{ fee && currency && currency.toUpperCase() }}</span>
          </div>
          <span
            v-if="fee ===null || fee === '' || fee === undefined"
            class="text-danger mt-1"
          >
            <b-icon
              icon="info-circle"
              variant="danger"
              class="mr-1"
            />
            {{ $t('receipt.feeNotAvailable') }}
          </span>
          <dashboard-alert
            v-if="showInternalWithdrawWarning"
            class="mt-1"
            variant="info"
            :description="$t('receipt.internalWithdrawWarning')"
          />
        </b-list-group-item>
        <b-list-group-item class="bg-light d-flex justify-content-between align-items-center border-0">
          <span>{{ $t('total') }}:</span>
          <span dir="ltr">{{ total }}</span>
        </b-list-group-item>
      </b-list-group>

      <b-button
        block
        variant="info"
        class="receipt-confirm-btn"
        :disabled="fee === null || fee === '' || fee === undefined"
        @click="$emit('confirm')"
      >
        {{ $t('confirm') }}
      </b-button>
    </b-overlay>
  </b-modal>
</template>

<script>
import DashboardAlert from '@/views/theme2/dashboard/dashboardAlert.vue'

export default {
  name: 'Receipt',
  components: {
    DashboardAlert,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    date: {
      type: String,
      required: true,
    },
    address: {
      type: String,
      required: false,
      default: null,
    },
    iban: {
      type: String,
      required: false,
      default: null,
    },
    fee: {
      type: [String, Number],
      required: true,
    },
    network: {
      type: String,
      required: false,
      default: null,
    },
    currency: {
      type: String,
      required: true,
    },
    amount: {
      type: [String, Number],
      required: true,
    },
    total: {
      type: [String, Number],
      required: true,
    },
    showInternalWithdrawWarning: {
      type: Boolean,
      default: false,
    },
    onClose: {
      type: Function,
      default: null,
    },
  },
  methods: {
    handleClose() {
      this.$emit('close')
      if (typeof this.onClose === 'function') {
        this.onClose()
      }
    },
  },
}
</script>

<style scoped>
.receipt-modal-content {
  border-radius: 18px;
  padding: 0;
}

.receipt-modal-dialog {
  max-width: 420px;
}

.receipt-title {
  font-size: 1.25rem;
}

.close-btn {
}

.receipt-list-group {
  border-radius: 12px;
  overflow: hidden;
  margin-top: 1rem;
}

.bg-light {
}

.receipt-confirm-btn {
  margin-top: 1.5rem;
  border-radius: 16px;
  font-size: 1.1rem;
  font-weight: 500;
  padding: 0.75rem 0;
}
</style>
